<template>
  <b-popover
    v-if="targetId"
    ref="popover"
    :target="`schools-popover-${targetId}`"
    triggers="hover"
    :placement="placement"
    :html="true"
    custom-class="popover-lg"
  >
    <div v-for="(school, index) in schools" :key="school.id" :class="{ 'mb-3': index < schools.length - 1 }">
      <md-icon class="text-50 icon-16pt">check_circle</md-icon>
      <strong class="ml-2">{{ school.name }}</strong>
    </div>
  </b-popover>
</template>

<script>
import MdIcon from '@/components/Ui/MdIcon.vue';

export default {
  name: 'SchoolsListPopover',
  components: { MdIcon },

  props: {
    schools: { type: Array, default: () => [] },
    targetId: { required: true },
    placement: { type: String, default: 'left' },
  },

  data() {
    return {};
  },

  methods: {},

  async mounted() {},
};
</script> 